import { Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-admin-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.css']
})
export class TemplateComponent implements OnInit{

  constructor(
  ) { }

  ngOnInit() {
  }

}
